var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4724 25.6693L8.3542 22.1111L4.32311 21.2457L4.71838 17.1039L2 14.0026L4.71838 10.9013L4.32311 6.75956L8.3542 5.89411L10.4724 2.33594L14.25 3.9256L18.0276 2.33594L20.1458 5.89411L24.1769 6.75956L23.7816 10.9013L26.5 14.0026L23.7816 17.1039L24.1769 21.2457L20.1458 22.1111L18.0276 25.6693L14.25 24.0796L10.4724 25.6693ZM11.0142 24.0505L14.25 22.7089L17.5004 24.0505L19.3257 21.0172L22.8153 20.2443L22.4981 16.6568L24.8456 14.0026L22.4981 11.3339L22.8153 7.74634L19.3257 6.98801L17.4858 3.95467L14.25 5.29629L10.9996 3.95467L9.17425 6.98801L5.68468 7.74634L6.00191 11.3339L3.65438 14.0026L6.00191 16.6568L5.68468 20.2589L9.17425 21.0172L11.0142 24.0505ZM12.9176 17.6145L19.2087 11.3484L18.3106 10.4394L12.9176 15.8109L10.1894 13.1081L9.29131 14.0026L12.9176 17.6145Z",
    fill: "#00AF00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareSuccess);
export default __webpack_public_path__ + "static/media/share_success.029febffa902e9bc97b635ccad346b4f.svg";
export { ForwardRef as ReactComponent };